<template>
  <a-switch
    v-if="getShowDarkModeToggle"
    :class="getClass"
    class="app-dark-mode-toggle"
    @click="toggleDarkMode"
    v-model:checked="checked1"
    checked-children="暗黑"
    un-checked-children="明亮"
    style="width: 70px"
  />
</template>
<script lang="ts" setup>
  import { computed, unref } from 'vue';
  import { useDesign } from '@/hooks/web/useDesign';
  import { useRootSetting } from '@/hooks/setting/useRootSetting';
  import { updateHeaderBgColor, updateSidebarBgColor } from '@/logics/theme/updateBackground';
  import { updateDarkTheme } from '@/logics/theme/dark';
  import { ThemeEnum } from '@/enums/appEnum';

  const { prefixCls } = useDesign('dark-switch');
  const { getDarkMode, setDarkMode, getShowDarkModeToggle } = useRootSetting();
  const isDark = computed(() => getDarkMode.value === ThemeEnum.DARK);
  const checked1 = ref(isDark.value);

  const getClass = computed(() => [
    prefixCls,
    {
      [`${prefixCls}--dark`]: unref(isDark),
    },
  ]);

  function toggleDarkMode() {
    const darkMode = getDarkMode.value === ThemeEnum.DARK ? ThemeEnum.LIGHT : ThemeEnum.DARK;
    setDarkMode(darkMode);
    updateDarkTheme(darkMode);
    updateHeaderBgColor();
    updateSidebarBgColor();
  }
</script>
<style lang="less" scoped>
  @prefix-cls: ~'@{namespace}-dark-switch';

  .app-dark-mode-toggle {
    background-color: @primary-color;
  }

  html[data-theme='dark'] {
    .@{prefix-cls} {
      border: none;
    }

    .app-dark-mode-toggle {
      background: #6f7485 !important;
      color: white;
    }
  }

  :deep(.ant-switch-handle) {
    top: 3px;
    left: 4px;

    &::before {
      background-color: rgb(93 95 239);
    }
  }

  :deep(.ant-switch-inner) {
    padding-top: 2px;
  }

  :deep(.ant-switch-inner .ant-switch-inner-unchecked) {
    color: #666;
  }

  :deep(.ant-switch-inner .ant-switch-inner-checked) {
    color: #fff;
  }

  :deep(.ant-switch-handle::before) {
    top: 2px;
  }

  .@{prefix-cls} {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: space-between;
    width: 50px;
    height: 26px;
    margin-left: auto;
    padding: 0 6px;
    border-radius: 30px;
    background-color: #fff !important;
    cursor: pointer;

    &-inner {
      position: absolute;
      z-index: 1;
      width: 18px;
      height: 18px;
      transition:
        transform 0.5s,
        background-color 0.5s;
      border-radius: 50%;
      background-color: #fff;
      will-change: transform;
    }

    &--dark {
      .@{prefix-cls}-inner {
        transform: translateX(calc(100% + 2px));
      }
    }
  }
</style>
<style>
  html[data-theme='dark'] .app-dark-mode-toggle .ant-switch-handle::before {
    background-color: #5d5fef;
  }

  html[data-theme='dark'] .app-dark-mode-toggle .ant-switch-checked .ant-switch-handle {
    left: calc(100% - 23px);
  }
</style>
